import { Stomp } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { Url } from '../Constants/Url';

class WebSocketService {
  constructor(baseUrl) {
    this.client = null;
    this.callbackMethods = {};
    this.currentRequestId = null;
    this.currentSellerCompanyId = null;
  }

  connect(requestId, sellerCompanyId) {
    if (
      this.client &&
      this.client.connected &&
      this.currentRequestId === requestId &&
      this.currentSellerCompanyId === sellerCompanyId
    ) {
      return;
    }

    if (this.client) {
      try { this.client.disconnect(); } catch (e) {}
      this.client = null;
    }

    this.currentRequestId = requestId;
    this.currentSellerCompanyId = sellerCompanyId;

    let sock = new SockJS(Url.BASE_URL_SOCKET);
    this.client = Stomp.over(sock);
    this.client.heartbeat.outgoing = 10000; 
    this.client.heartbeat.incoming = 1000;
    this.client.connect({}, (frame) => {
      if(sellerCompanyId != null){
        this.subscribeToSellerChannel(requestId, sellerCompanyId, (notificationDto) => {
          this.handleRequest("myModule", JSON.parse(notificationDto));
        });
      }else{
        this.subscribeToUserChannel(requestId, (notificationDto) => {
          this.handleRequest("myModule", JSON.parse(notificationDto));
        });
      }
    });
  }

  disconnect() {
    if (this.client) {
      try { this.client.disconnect(); } catch (e) {}
      this.client = null;
    }
    this.currentRequestId = null;
    this.currentSellerCompanyId = null;
  }

  subscribeToUserChannel(requestId, callback) {
    this.client.subscribe(`/topic/` + requestId, (message) => {
      console.log("this is your message" + message);
      callback(message.body);
    });
  }

  subscribeToSellerChannel(requestId, sellerCompanyId, callback) {
    this.client.subscribe(`/topic/` + requestId + `/` + sellerCompanyId, (message) => {
      console.log("this is your message" + message);
      callback(message.body);
    });
  }

  subscribe(module, callbackMethod) {
    this.callbackMethods[module] = callbackMethod;
  }

  handleRequest(module, data) {
    if (this.callbackMethods[module]) {
      this.callbackMethods[module](data);
    }
  }
}

const baseUrl = process.env.REACT_APP_SOCK_URL;
const webSocketService = new WebSocketService(baseUrl);

export default webSocketService;

// import SockJS from 'sockjs-client';
// import { Stomp } from '@stomp/stompjs';
// import { Url } from '../Constants/Url';

// class WebSocketService {
//   constructor(baseUrl) {
//     this.client = null;
//     this.callbackMethods = {};
//   }

//   connect(userId) {
//     const sock = new SockJS(Url.BASE_URL_SOCKET);
//     this.client = Stomp.over(sock);
//     this.client.connect({}, (frame) => {
//       console.log('Connected to WebSocket', frame);
//       this.subscribeToUserChannel(userId, (notificationDto) => {
//         console.log('Received message:', JSON.parse(notificationDto));
//         const module = window.location.pathname.replace(/\//g, '');
//         this.handleRequest('notifications', JSON.parse(notificationDto));
//       });
//     });
//   }

//   disconnect() {
//     if (this.client !== null) {
//       this.client.disconnect();
//       this.client = null;
//     }
//   }

//   subscribeToUserChannel(userId, callback) {
//     this.client.subscribe(`/topic/user/${userId}`, (message) => {
//       callback(message.body);
//     });
//   }

//   subscribe(module, callbackMethod) {
//     this.callbackMethods[module] = callbackMethod;
//   }

//   handleRequest(module, data) {
//     if (this.callbackMethods[module]) {
//       this.callbackMethods[module](data);
//     }
//   }
// }

// const baseUrl = process.env.REACT_APP_SOCK_URL || Url.BASE_URL_SOCKET;
// const webSocketService = new WebSocketService(baseUrl);

// export default webSocketService;

